import React from "react";

const Benefits = () => {
  return (
    <div className="erp-integration-benefits-wrapper">
      <h1>
        Benefits of <span>ERP</span> Integration
      </h1>
      <div className="row">
        <div className="col-12 col-sm-6 col-lg-3">
          <div className="card">
            <p>Improved decision-making with real-time data visibility</p>
          </div>
        </div>
        <div className="col-12 col-sm-6 col-lg-3">
          <div className="card">
            <p>Enhanced cross-department collaboration</p>
          </div>
        </div>
        <div className="col-12 col-sm-6 col-lg-3">
          <div className="card">
            <p>Reduced operational costs through process automation</p>
          </div>
        </div>
        <div className="col-12 col-sm-6 col-lg-3">
          <div className="card">
            <p>Scalability to support organizational growth</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Benefits;
